var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TopBar',{attrs:{"layout":"simple"}}),_c('el-container',{attrs:{"id":"tf-app-container"}},[_c('el-container',{attrs:{"id":"tf-content"}},[_c('router-view')],1)],1),_c('ContinueOnDesktop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }